export default "__VITE_ASSET__BshXpKTT__"